var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHasNoAccessFlat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99982 11.3587C8.71763 11.3587 9.29954 10.7768 9.29954 10.059C9.29954 9.34118 8.71763 8.75928 7.99982 8.75928C7.28201 8.75928 6.7001 9.34118 6.7001 10.059C6.7001 10.7768 7.28201 11.3587 7.99982 11.3587Z",
    stroke: "#001E2E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99982 11.3586V12.9183",
    stroke: "#001E2E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1987 6.67969H2.80095C2.51383 6.67969 2.28107 6.91245 2.28107 7.19957V14.478C2.28107 14.7651 2.51383 14.9979 2.80095 14.9979H13.1987C13.4858 14.9979 13.7186 14.7651 13.7186 14.478V7.19957C13.7186 6.91245 13.4858 6.67969 13.1987 6.67969Z",
    stroke: "#001E2E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66034 6.67971V4.34022C5.66034 3.71975 5.90682 3.12469 6.34556 2.68595C6.7843 2.24721 7.37936 2.00073 7.99983 2.00073C8.6203 2.00073 9.21536 2.24721 9.6541 2.68595C10.0928 3.12469 10.3393 3.71975 10.3393 4.34022V6.67971",
    stroke: "#001E2E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHasNoAccessFlat);
export default __webpack_public_path__ + "static/media/hasNoAccess-flat.add4979ebb8bab2989a067c3cafb1bf7.svg";
export { ForwardRef as ReactComponent };